<template>
  <div>
    <v-dialog hide-overlay v-model="log_list_modal" persistent max-width="1000px">
      <v-card tile :loading="log_list_loading">
        <v-card-title class="pa-0">
          <v-row dense="" no-gutters>
            <v-col class="d-flex justify-center">
              <v-card-title class="pa-0 pt-2">
                Logs
                <div class="d-flex justify-space-around ml-5">
                  <v-tooltip bottom="" v-if="selectedRows2.length > 0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab
                        x-small
                        color="error"
                        v-if="user_is_main_admin==1"
                        v-bind="attrs"
                        v-on="on"
                        @click="deleteLogs"
                      >
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Remove Log(s)</span>
                  </v-tooltip>
                </div>
              </v-card-title>
            </v-col>
            <v-col cols="1">
              <v-menu bottom :close-on-content-click="false" content-class="elevation-0" v-model="filter_menu">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn  dark icon v-bind="attrs" v-on="on" class="ml-7 header_btn">
                      <span class="lable_class">Filter</span>
                      <v-icon size="22px" style="color:#bdbdbd" >mdi-filter-menu-outline</v-icon>
                  </v-btn>
                </template> 
                <v-card tile max-width="400" class="mb-5 mr-5" >
                  <v-list class="filter-section-border">
                    <v-list-item class="mt-0 float-right" >
                      <!-- <v-text-field
                        v-model="pagination.search"
                        append-icon="mdi-magnify"
                        label="Search"
                        hide-details
                        dense
                        outlined=""
                        placeholder=" "
                        clearable
                        autofocus
                        v-on:keyup.enter="search_menu = false"
                        class="mr-2"
                      ></v-text-field> -->
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" class="error" @click="resetFilter()" icon small><v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon></v-btn>
                        </template>
                        <span>Reset</span>
                      </v-tooltip>
                    </v-list-item>
                    <v-list-item class="mt-1">
                      <v-autocomplete
                        dense
                        flat
                        :items="events_filter"
                        outlined
                        label="Document Type"
                        hide-details
                        class="body-2"
                        placeholder="All"
                        v-model="pagination.filters.doc_type"
                        clearable=""
                       >
                        <template v-slot:item="{ item }">
                          <div :class="{ 'highlighted-option': item.value === 'Order Amount Value' }" v-bind="attrs" v-on="on">
                            {{ item.text }}
                          </div>
                        </template>
                      </v-autocomplete> 
                    </v-list-item>
                  </v-list>
                  <v-card-title class="pa-0">
                      <v-btn
                        fab
                        color="error"
                        x-small
                        absolute
                        @click="filter_menu = false"
                        class="custom-close-btn"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                </v-card>
            </v-menu>
              </v-col>
            <v-col cols="1" style="max-width: 4%;">
              <v-icon size="30" class="mt-2 drag-icon">mdi-drag-variant</v-icon>
            </v-col>
            <v-col cols="1" class="" style="max-width: 5%;">
              <v-btn
                fab
                color="error"
                x-small
                @click="setLogData({key : 'log_list_modal',value : false})"
                class="custom-close-btn mt-2"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-row dense="" no-gutters class="grey lighten-1 ma-1 mt-2">
          <v-col cols="3" class="text-center" style="border-right: solid 1px grey;">
            <span v-if="bank_name">{{bank_name}}</span>
            <span v-if="item_name">{{item_name}}</span>
            <span v-if="job_name">{{job_name}}</span>
            <span v-if="user_name">{{user_name}}</span>
          </v-col>
          <v-col cols="3" class="text-center" style="border-right: solid 1px grey;">
            <span v-if="vendor_name">{{vendor_name}}</span>
            <span v-if="customer_name">{{customer_name}}</span> 
          </v-col>
          <v-col cols="3" class="text-center" style="border-right: solid 1px grey;">
            <span v-if="project_name">{{project_name}}</span>
          </v-col>
          <v-col cols="3" class="text-center">
            <span v-if="form_name">{{form_name}}</span>
          </v-col>
        </v-row>
        <v-card-text class="pa-1 mx-auto">
          <v-row dense="" no-gutters>
            <v-col cols="3">
              <v-autocomplete
                outlined="" 
                label="Event" 
                dense
                :hide-details="!form_errors.event"
                :items="events"
                v-model="form_data_temp.event"
                :error-messages="form_errors.event"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="6" class="ml-2">
              <v-textarea
              outlined=""
              rows="1"
              label="Description"
              v-model="form_data_temp.description"
              dense=""
              :error-messages="form_errors.description"
              :hide-details="!form_errors.description"
              ></v-textarea>
            </v-col>
            <v-col class="ml-2">
              <v-btn color="primary" :loading="log_list_loading" @click="addLog(form_data_temp)">
                Add
              </v-btn>
              <v-btn class="ml-2" @click="resetData();" color="error" :disabled="log_list_loading">Reset</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="pa-1 mx-auto">
          <v-data-table
            :headers="headers"
            class="elevation-1 rounded-0 my-transaction-table document-list"
            :items="log_items.data"
            dense
            :server-items-length="log_items.total"
            :options.sync="pagination"
            mobile-breakpoint="50"
            :footer-props="{ 'items-per-page-options': pagination_settings.perPageList }"
          >
            <template v-slot:item.checkbox="{item}" class="td">
              <v-simple-checkbox v-model="item.selected" :ripple="false"></v-simple-checkbox>
            </template>
            <template v-slot:item.created_at="{item}" class="td">
              {{displayDateTimeFormate(item.created_at)}}
            </template>
            <template v-slot:item.number="{item}" class="td">
              {{getLogNumber(item.log_id)}}
            </template>
            <!-- <template v-slot:item.text="{}" class="td">
              <v-icon>mdi-message</v-icon>
            </template> -->
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "../../plugins/axios";
import { mapState, mapMutations, mapActions } from "vuex";
import { parseParams } from "../../plugins/helper";
const moment = require('moment');
export default {
  name: "LogList",
  data: () => ({
    form_data_temp : {},
    filter_menu: false,
    user_is_main_admin : localStorage.getItem('user_is_main_admin'),
    events: [
      {value: 'General', text: 'General'},
      {value: 'User', text: 'User'},
      {value: 'Admin', text: 'Admin'},
      {value: 'Accounts Payable', text: 'Accounts Payable'},
      {value: 'Accounts Recivable', text: 'Accounts Recivable'},
      {value: 'Vendor', text: 'Vendor'},
      {value: 'Customer', text: 'Customer'},
      {value: 'Template', text: 'Template'},
      {value: 'Fabrication', text: 'Fabrication'},
      {value: 'SRQ', text: 'SRQ'},
      {value: 'GCT', text: 'GCT'},
    ],
      events_filter: [
      {value: 'General', text: 'General'},
      {value: 'User', text: 'User'},
      {value: 'Admin', text: 'Admin'},
      {value: 'Accounts Payable', text: 'Accounts Payable'},
      {value: 'Accounts Recivable', text: 'Accounts Recivable'},
      {value: 'Vendor', text: 'Vendor'},
      {value: 'Customer', text: 'Customer'},
      {value: 'Template', text: 'Template'},
      {value: 'Fabrication', text: 'Fabrication'},
      {value: 'SRQ', text: 'SRQ'},
      {value: 'GCT', text: 'GCT'},
      {value: 'Order Amount Value', text: 'Order Amount Value'},
    ],
    headers: [
      { value: "checkbox", text: "#", sortable: false, align:'center', width: '2.5%' },
      { value: "number", text: "No", sortable: false, width: '3%' },
      { value: "created_at", text: "Date", sortable: false, width: '17.5%'},
      { value: "event", text: "Event", sortable: false, width: '17%' },
      { value: "description", text: "Description", sortable: false, width: '35%' },
      { value: "user.full_name", text: "User", sortable: false, width: '21%' },
      // { value: "text", text: "Text", sortable: false, width: '4%' },
    ],
    pagination: {
      itemsPerPage: 20,
      sortBy: ["created_at"],
      page: 1,
      filters: {
      doc_type: "",
      },
    }
  }),
  watch: {
    form_data: {
      handler() {
        this.resetData();
        this.getLogs();
      }
    },
    log_list_modal: {
      handler(val) {
        if(!val){
          this.resetData();
          this.setLogData({key : 'form_errors',value : []})
        } else {
          this.getLogs();
        }
      },
    },
    refresh_log_list: {
      handler() {
        this.resetData();
        this.setLogData({key : 'form_errors',value : []})
        this.getLogs();
      },
    },
    pagination: {
      handler() {
        this.getLogs(parseParams(this.pageData));
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("log", [
      "log_list_loading",
      "log_list_modal",
      "form_name",
      "bank_name",
      "project_name",
      "vendor_name",
      "item_name",
      "job_name",
      "user_name",
      "customer_name",
      "item",
      "form_data",
      "log_items",
      "type",
      "form_errors",
      "refresh_log_list",
    ]),
    ...mapState("utils", ["pagination_settings"]),
    pageData() {
      let paginationData = this.pagination;
      return paginationData;
    },
    selectedRows2() {
      if(this.log_items.data) {
        return this.log_items.data.filter(function (item) {
          return item.selected == true;
        });
      } else {
        return []
      }
    },
  },
  methods: {
    ...mapActions("log", ["addLog","getLogs"]),
    ...mapMutations("log", ["setLogData"]),
    ...mapMutations("utils", ["setAlert"]),
    resetFilter() {
      this.pagination.filters.doc_type = ""
      
    },
    getLogNumber(log_id) {
      let index_number = ''
      this.log_items.data.filter((item,index) => {
        if(item.log_id == log_id) {
          index_number = index + 1
        }
      })
      return index_number 
    },
    resetData() {
      this.form_data_temp = {}
    },
    displayDateTimeFormate(date) {
      return moment(date).format('MM/DD/YYYY H:mm:ss');
    },
    deleteLogs() {
      let _self = this;
      let ids = [];
      this.selectedRows2.map(function (item) {
        ids.push(item.log_id);
      });
      axios
        .post("delete_log", {
          ids: ids,
        })
        .then(function () {
          _self.getLogs();
          // _self.setAlert({
          //     show: true,
          //     variant: "primary",
          //     message: response.data.message,
          //     dismissCountDown: 0,
          //   });
          _self.item.logs_count = _self.item.logs_count - ids.length
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
  },
};

</script>
<style scoped>
.highlighted-option {
  background-color:#a61f38 ; /* Change this to your desired background color */
}
</style>